module.exports = __webpack_public_path__ + "static/media/unboxing_goodypack_right.4b703c0e.jpg";